import { Component, OnInit, OnDestroy } from '@angular/core';
import { ChatNotificationService, ChatNotification } from '../services/chat-notification.service';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-chat-notification-widget',
  templateUrl: './chat-notification-widget.component.html',
  styleUrls: ['./chat-notification-widget.component.css']
})
export class ChatNotificationWidgetComponent implements OnInit, OnDestroy {
  notification: ChatNotification = { unreadCount: 0, messages: [], hasNewMessages: false };
  isMinimized = true;
  currentUser: any;
  private subscription: Subscription = new Subscription();

  constructor(
    private chatService: ChatNotificationService,
    private router: Router
  ) {
    this.currentUser = JSON.parse(localStorage.getItem('currentUser') || '{}');
  }

  ngOnInit() {
    this.initializeWidget();

    // Listen for storage changes (login/logout)
    window.addEventListener('storage', () => {
      this.initializeWidget();
    });

    // Re-check periodically in case user logs in
    setInterval(() => {
      const shouldShow = this.shouldShowWidget();
      const hasSubscription = this.subscription && !this.subscription.closed;

      if (shouldShow && !hasSubscription) {
        this.initializeWidget();
      } else if (!shouldShow && hasSubscription) {
        this.subscription.unsubscribe();
        this.notification = { unreadCount: 0, messages: [], hasNewMessages: false };
      }
    }, 1000);
  }

  shouldPoll(): boolean {
    return this.currentUser.salon_id &&
      this.currentUser.whatsAppEnabled === '1' &&
      this.currentUser.incomingMessage === '1';
  }

  private initializeWidget() {
    if (this.shouldShowWidget()) {
      // Unsubscribe previous subscription if exists
      if (this.subscription) {
        this.subscription.unsubscribe();
      }

      this.subscription = new Subscription();
      this.subscription.add(
        this.chatService.getNotifications().subscribe(notification => {
          this.notification = notification;
        })
      );
    }
  }

  shouldShowWidget(): boolean {
    // Always refresh currentUser from localStorage
    this.currentUser = JSON.parse(localStorage.getItem('currentUser') || '{}');

    return this.currentUser.salon_id &&
      this.currentUser.whatsAppEnabled === '1';
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    this.chatService.stopPolling();

    // Remove storage event listener
    window.removeEventListener('storage', () => {
      this.initializeWidget();
    });
  }

  toggleWidget() {
    this.isMinimized = !this.isMinimized;
  }

  openFullChat() {
    this.router.navigate(['/whatsapp-chat']);
  }

  openMessage(message: any) {
    this.router.navigate(['/whatsapp-chat'], {
      queryParams: { customer: message.customer_wa_id }
    });
  }

  formatTime(dateString: string): string {
    return new Date(dateString).toLocaleTimeString('en-US', {
      hour: '2-digit',
      minute: '2-digit'
    });
  }
}


// WEBPACK FOOTER //
// ./src/app/chat-notification-widget/chat-notification-widget.component.ts